export default __webpack_public_path__ + "static/logo_horizontal_positive_mono_lockup-ab5262e265c7453a644f2e3adf6e9a4d.svg";